<div class="snackbar-wrapper">
  <span class="text" [innerHtml]="data.description"></span>
  <div class="mat-simple-snackbar-action" style="max-width: 87px;">
    <button class="snackbarButton" (click)="dismiss()" mat-button>{{ data.buttonText }}</button>
  </div>
</div>
